import k from "./objectWithoutPropertiesLoose3.mjs";
import c from "./extends3.mjs";
import * as Y from "react";
import e from "./index180.mjs";
import { clsx as K } from "./clsx.mjs";
import { useLocaleText as J, useUtils as Q } from "./useUtils.mjs";
import { PickersFadeTransitionGroup as X } from "./PickersFadeTransitionGroup.mjs";
import { ArrowDropDownIcon as Z } from "./index243.mjs";
import { useNextMonthDisabled as ee, usePreviousMonthDisabled as oe } from "./date-helpers-hooks.mjs";
import { pickersCalendarHeaderClasses as te, getPickersCalendarHeaderUtilityClass as ie } from "./pickersCalendarHeaderClasses.mjs";
import { jsxs as H, jsx as s } from "react/jsx-runtime";
import d from "./styled.mjs";
import ne from "./IconButton.mjs";
import se from "./useThemeProps.mjs";
import { useSlotProps as B } from "./useSlotProps.mjs";
import re from "./Fade.mjs";
import { PickersArrowSwitcher as ae } from "./PickersArrowSwitcher.mjs";
import le from "./composeClasses.mjs";
const ce = ["slots", "slotProps", "components", "componentsProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone"], de = ["ownerState"], me = (o) => {
  const {
    classes: t
  } = o;
  return le({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, ie, t);
}, ue = d("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (o, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), he = d("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (o, t) => t.labelContainer
})(({
  theme: o
}) => c({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, o.typography.body1, {
  fontWeight: o.typography.fontWeightMedium
})), we = d("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (o, t) => t.label
})({
  marginRight: 6
}), pe = d(ne, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (o, t) => t.switchViewButton
})(({
  ownerState: o
}) => c({
  marginRight: "auto"
}, o.view === "year" && {
  [`.${te.switchViewIcon}`]: {
    transform: "rotate(180deg)"
  }
})), fe = d(Z, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (o, t) => t.switchViewIcon
})(({
  theme: o
}) => ({
  willChange: "transform",
  transition: o.transitions.create("transform"),
  transform: "rotate(0deg)"
})), be = /* @__PURE__ */ Y.forwardRef(function(t, P) {
  var v, C, V, y;
  const f = J(), m = Q(), u = se({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: r,
    slotProps: a,
    components: h,
    currentMonth: n,
    disabled: x,
    disableFuture: D,
    disablePast: N,
    maxDate: T,
    minDate: _,
    onMonthChange: M,
    onViewChange: b,
    view: w,
    reduceAnimations: j,
    views: i,
    labelId: L,
    className: q,
    timezone: I
  } = u, A = k(u, ce), p = u, l = me(u), R = (v = (C = r?.switchViewButton) != null ? C : h?.SwitchViewButton) != null ? v : pe, O = B({
    elementType: R,
    externalSlotProps: a?.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": f.calendarViewSwitchingButtonAriaLabel(w)
    },
    ownerState: p,
    className: l.switchViewButton
  }), S = (V = (y = r?.switchViewIcon) != null ? y : h?.SwitchViewIcon) != null ? V : fe, F = B({
    elementType: S,
    externalSlotProps: a?.switchViewIcon,
    ownerState: void 0,
    className: l.switchViewIcon
  }), z = k(F, de), U = () => M(m.addMonths(n, 1), "left"), G = () => M(m.addMonths(n, -1), "right"), W = ee(n, {
    disableFuture: D,
    maxDate: T,
    timezone: I
  }), $ = oe(n, {
    disablePast: N,
    minDate: _,
    timezone: I
  }), E = () => {
    if (!(i.length === 1 || !b || x))
      if (i.length === 2)
        b(i.find((g) => g !== w) || i[0]);
      else {
        const g = i.indexOf(w) !== 0 ? 0 : 1;
        b(i[g]);
      }
  };
  return i.length === 1 && i[0] === "year" ? null : /* @__PURE__ */ H(ue, c({}, A, {
    ownerState: p,
    className: K(q, l.root),
    ref: P,
    children: [/* @__PURE__ */ H(he, {
      role: "presentation",
      onClick: E,
      ownerState: p,
      "aria-live": "polite",
      className: l.labelContainer,
      children: [/* @__PURE__ */ s(X, {
        reduceAnimations: j,
        transKey: m.format(n, "monthAndYear"),
        children: /* @__PURE__ */ s(we, {
          id: L,
          ownerState: p,
          className: l.label,
          children: m.format(n, "monthAndYear")
        })
      }), i.length > 1 && !x && /* @__PURE__ */ s(R, c({}, O, {
        children: /* @__PURE__ */ s(S, c({}, z))
      }))]
    }), /* @__PURE__ */ s(re, {
      in: w === "day",
      children: /* @__PURE__ */ s(ae, {
        slots: r,
        slotProps: a,
        onGoToPrevious: G,
        isPreviousDisabled: $,
        previousLabel: f.previousMonth,
        onGoToNext: U,
        isNextDisabled: W,
        nextLabel: f.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (be.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * className applied to the root element.
   */
  className: e.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: e.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: e.object,
  currentMonth: e.any.isRequired,
  disabled: e.bool,
  disableFuture: e.bool,
  disablePast: e.bool,
  labelId: e.string,
  maxDate: e.any.isRequired,
  minDate: e.any.isRequired,
  onMonthChange: e.func.isRequired,
  onViewChange: e.func,
  reduceAnimations: e.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  timezone: e.string.isRequired,
  view: e.oneOf(["day", "month", "year"]).isRequired,
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired).isRequired
});
export {
  be as PickersCalendarHeader
};
//# sourceMappingURL=PickersCalendarHeader.mjs.map
